import clsx from "clsx";
import type { ReactNode, HTMLAttributes } from "react";
import { forwardRef } from "react";

import { AlertContext } from "../context";
import type { Severity } from "../types";
import { DEFAULT_SEVERITY } from "../utils";

import styles from "./root.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
    severity?: Severity;
};

const Root = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const {
        children,
        className,
        severity = DEFAULT_SEVERITY,
        ...otherProps
    } = props;

    return (
        <AlertContext.Provider value={{ severity }}>
            <div
                ref={ref}
                className={clsx(styles.alert, className)}
                role="alert"
                {...otherProps}
                data-severity={severity}
            >
                {children}
            </div>
        </AlertContext.Provider>
    );
});
Root.displayName = "Alert";

export { Root };
export type { Props as RootProps };
